(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoDialogController', SSPeriodoDialogController);

    SSPeriodoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSPeriodo', 'SSAnio'];

    function SSPeriodoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSPeriodo, SSAnio) {
        var vm = this;

        vm.sSPeriodo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssanios = SSAnio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSPeriodo.id !== null) {
                SSPeriodo.update(vm.sSPeriodo, onSaveSuccess, onSaveError);
            } else {
                SSPeriodo.save(vm.sSPeriodo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSPeriodoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.iniPeriodo = false;
        vm.datePickerOpenStatus.finPeriodo = false;
        vm.datePickerOpenStatus.iniConvocatoria = false;
        vm.datePickerOpenStatus.finConvocatoria = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
